// Cloudinary Configuration
// Update these values with your actual Cloudinary credentials

export const CLOUDINARY_CONFIG = {
    // Your Cloudinary cloud name (get from https://cloudinary.com/console)
    CLOUD_NAME: 'dyazihpys',

    // Your upload preset (create one in Cloudinary dashboard)
    UPLOAD_PRESET: 'ml_default',

    // Optional: API credentials for server-side operations
    API_KEY: '366154995756795',
    API_SECRET: 'ILx0mYJElW9L8_XT-862NWBdIM4',

    // Upload folders for organization
    FOLDERS: {
        STUDENTS: 'students',
        STAFF: 'staff',
        TEACHERS: 'teachers',
        PROFILE_IMAGES: 'profile_images',
        DOCUMENTS: 'documents',
        ANNOUNCEMENTS: 'announcements',
    },

    // Image transformation settings
    TRANSFORMATIONS: {
        PROFILE_THUMBNAIL: {
            width: 150,
            height: 150,
            crop: 'fill',
            quality: 'auto',
            format: 'auto'
        },
        PROFILE_LARGE: {
            width: 400,
            height: 400,
            crop: 'fill',
            quality: 'auto',
            format: 'auto'
        },
        DOCUMENT_PREVIEW: {
            width: 300,
            height: 400,
            crop: 'fit',
            quality: 'auto',
            format: 'auto'
        }
    }
};

// Validation function to check if configuration is complete
export const validateCloudinaryConfig = (): boolean => {
    const { CLOUD_NAME, UPLOAD_PRESET } = CLOUDINARY_CONFIG;

    if (!CLOUD_NAME || CLOUD_NAME === 'your_cloudinary_cloud_name') {
        console.warn('⚠️  Cloudinary cloud name not configured. Please update CLOUDINARY_CONFIG.CLOUD_NAME');
        return false;
    }

    if (!UPLOAD_PRESET || UPLOAD_PRESET === 'your_upload_preset_name') {
        console.warn('⚠️  Cloudinary upload preset not configured. Please update CLOUDINARY_CONFIG.UPLOAD_PRESET');
        return false;
    }

    return true;
};

// Helper function to get Cloudinary URL
export const getCloudinaryUrl = (publicId: string, transformations?: Record<string, any>): string => {
    const baseUrl = `https://res.cloudinary.com/${CLOUDINARY_CONFIG.CLOUD_NAME}/image/upload`;

    if (!transformations || Object.keys(transformations).length === 0) {
        return `${baseUrl}/${publicId}`;
    }

    const transformString = Object.entries(transformations)
        .map(([key, value]) => `${key}_${value}`)
        .join(',');

    return `${baseUrl}/${transformString}/${publicId}`;
};
